import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { Ticket } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";

export const FloatingCoupon = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (pathname !== "/") return;
    const onScroll = () => {
      const pastHero = window.scrollY > window.innerHeight * 0.85;
      let formIn = false;
      const form = document.getElementById("coupon-form");
      if (form) {
        const r = form.getBoundingClientRect();
        formIn = r.top < window.innerHeight * 0.8 && r.bottom > 0;
      }
      setShow(pastHero && !formIn);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);

  if (pathname !== "/") return null;

  return (
    <motion.button
      initial={{ opacity: 0, y: 24 }}
      animate={{ opacity: show ? 1 : 0, y: show ? 0 : 24 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      style={{ pointerEvents: show ? "auto" : "none" }}
      onClick={() => scrollToSection("#coupon-form")}
      data-testid="floating-coupon-button"
      className="gold-glow fixed bottom-3 left-0 right-0 z-40 mx-auto flex w-fit items-center gap-2.5 bg-[#D4AF37] px-7 py-4 text-[11px] font-bold tracking-[0.18em] text-[#050505] shadow-2xl md:bottom-6 md:px-8 md:text-xs"
    >
      <Ticket size={17} /> PRENOTA −20% · POSTI LIMITATI
    </motion.button>
  );
};

export default FloatingCoupon;
